import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Colors } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Menu, Modal, Portal } from 'react-native-paper';
import { CreateFileForm } from './createFileForm';

type MediaType = 'file' | 'link';

export const CreateFileDropdown = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [selectedType, setSelectedType] = useState<MediaType | null>(null);

  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  const handleTypeSelect = (type: MediaType) => {
    setSelectedType(type);
    closeMenu();
  };

  const handleModalComplete = () => {
    setSelectedType(null);
  };

  return (
    <View style={styles.container}>
      <Menu
        visible={visible}
        onDismiss={closeMenu}
        contentStyle={styles.menuContent}
        anchor={
          <Pressable onPress={openMenu}>
            <View style={styles.anchor}>
              <MaterialCommunityIcons
                name="plus"
                color={Colors.blackText}
                size={16}
                style={styles.icon}
              />
              <Text style={styles.buttonText}>
                {t('file.dropdown.createFile')}
              </Text>
              <MaterialCommunityIcons
                name={visible ? 'chevron-up' : 'chevron-down'}
                color={Colors.blackText}
                size={16}
                style={styles.chevron}
              />
            </View>
          </Pressable>
        }
      >
        <Menu.Item
          leadingIcon="file-upload"
          onPress={() => handleTypeSelect('file')}
          title="File"
          style={styles.menuItem}
        />
        <Menu.Item
          leadingIcon="link"
          onPress={() => handleTypeSelect('link')}
          title="Link"
          style={styles.menuItem}
        />
      </Menu>

      <Portal>
        <Modal
          visible={!!selectedType}
          onDismiss={handleModalComplete}
          contentContainerStyle={styles.modalContainer}
        >
          {selectedType && (
            <CreateFileForm
              type={selectedType}
              onComplete={handleModalComplete}
            />
          )}
        </Modal>
      </Portal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
  },
  menuContent: {
    backgroundColor: Colors.white,
    flexDirection: 'column',
    flex: 1,
    top: 30,
  },
  anchor: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 151,
    height: 32,
    marginLeft: 20,
    backgroundColor: Colors.white,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: Colors.grayDivider,
  },
  icon: {
    marginRight: 4,
  },
  buttonText: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
    color: Colors.blackText,
  },
  chevron: {
    marginLeft: 4,
  },
  menuItem: {
    backgroundColor: Colors.white,
  },
  modalContainer: {
    alignSelf: 'center',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: 560,
    borderRadius: 12,
    backgroundColor: Colors.primaryGrayBackground,
  },
});
